// extracted by mini-css-extract-plugin
export default {"upsellWrapper":"nP","backgroundimage":"oP","header":"pP","headerwrap":"qP","title":"rP","promomessage":"sP","upsellItem":"tP","upsellImg":"uP","helperText":"vP","upsellHeadline":"wP","price":"xP","upsellGross":"yP","upsellNet":"zP","upsellButton":"AP","nutritionfacts":"BP","nutritionimg":"CP","containerwhy":"EP","nutritionwrappwer":"FP","headlinewhy":"GP","boxwhy":"HP","textwhy":"IP","backbutton":"JP","drawercontainer":"KP","logoheader":"LP","textwrap":"MP","timer":"NP"};
    if(module.hot) {
      // 1714442371423
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  